import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  universalCorporationId: string
  targetEmail: string
}

export class InviteCorporationMemberByEmailWriteRequest extends WriteRequest<void> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    const { targetEmail } = this.params
    return this.apiClient.post(this.makeEndpoint(), { targetEmail })
  }

  private makeEndpoint(): string {
    return `/corporation_account/corporation_member/${this.params.universalCorporationId}/corporation_member_invitation/create_by_email`
  }
}
